"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.persistedFetcher = exports.withPersistedQueries = void 0;
const withPersistedQueries = (fetchFunc, queryMap) => {
    return function (url, init) {
        if (typeof url !== 'string') {
            throw new Error('Request URL should be a string.');
        }
        if (typeof (init === null || init === void 0 ? void 0 : init.body) !== 'string') {
            const message = 'Request body should be a string.';
            console.error({ message, url, init });
            throw new Error(message);
        }
        let body;
        try {
            body = JSON.parse(init.body);
        }
        catch (error) {
            const message = 'Cannot parse request body.';
            console.error({ message, url, init });
            throw new Error(message);
        }
        if (!(body === null || body === void 0 ? void 0 : body.query) || typeof body.query !== 'string') {
            const message = 'Cannot find query in request body.';
            console.error({ message, url, init, body });
            throw new Error(message);
        }
        const query = body.query;
        const { queryType, queryId } = getQueryData(query, queryMap);
        const params = body;
        delete params.query;
        params.id = queryId;
        if (queryType === 'mutation') {
            return fetchFunc(url, Object.assign(Object.assign({}, init), { method: 'POST', headers: {
                    'Content-Type': 'application/json',
                }, body: JSON.stringify(params) }));
        }
        else {
            return fetchFunc(addQueryParamsToUrl(url, params), Object.assign(Object.assign({}, init), { method: 'GET', body: undefined }));
        }
    };
};
exports.withPersistedQueries = withPersistedQueries;
function persistedFetcher(endpoint, queryMap, query, variables, forcePostRequest) {
    const { queryType, queryId } = getQueryData(query, queryMap);
    return () => __awaiter(this, void 0, void 0, function* () {
        const params = { id: queryId, variables };
        let res;
        if (queryType === 'mutation' || forcePostRequest) {
            res = yield fetch(endpoint, Object.assign(Object.assign({ method: 'POST' }, { credentials: 'include' }), { headers: {
                    'Content-Type': 'application/json',
                }, body: JSON.stringify(params) }));
        }
        else {
            res = yield fetch(addQueryParamsToUrl(endpoint, params), Object.assign({ method: 'GET' }, { credentials: 'include' }));
        }
        const json = yield res.json();
        if (json.errors) {
            const { message } = json.errors[0];
            throw new Error(message);
        }
        return json.data;
    });
}
exports.persistedFetcher = persistedFetcher;
function getQueryData(query, queryMap) {
    const match = query.match(/((query)|(mutation)) ([A-Za-z0-9_]+)[ {(]/);
    if (!match) {
        throw new Error(`Cannot find query type and name. Query: ${query}`);
    }
    const queryType = match[1];
    const queryName = match[4];
    const queryId = queryMap[queryName];
    if (!queryId) {
        throw new Error(`Cannot find query ID. Query name: ${queryName}. Query map: ${JSON.stringify(queryMap)}`);
    }
    return { queryId, queryType };
}
function addQueryParamsToUrl(url, params) {
    return (url +
        '?' +
        new URLSearchParams(Object.assign({ id: params.id }, (typeof params.variables !== 'undefined'
            ? { variables: JSON.stringify(params.variables) }
            : {}))).toString());
}
// Lerna, please publish my changes!
